// Currency list extracted from constants.js to improve Vite dev server performance
// This prevents Vite from processing the entire 3,582 line constants.js file
// when only currency_list is needed

export const currency_list = [
  { name: 'Unknown Currency', code: 'unknown', symbol: '?', countryCode: '' },
  { name: 'Albania Lek', code: 'all', symbol: 'Lek', countryCode: 'al' },
  { name: 'Afghanistan Afghani', code: 'afn', symbol: '؋', countryCode: 'af' },
  { name: 'Argentina Peso', code: 'ars', symbol: '$', countryCode: 'ar' },
  { name: 'Aruba Guilder', code: 'awg', symbol: 'ƒ', countryCode: 'aw' },
  { name: 'Australia Dollar', code: 'aud', symbol: '$', countryCode: 'au' },
  { name: 'Azerbaijan Manat', code: 'azn', symbol: '₼', countryCode: 'az' },
  { name: 'Bahamas Dollar', code: 'bsd', symbol: '$', countryCode: 'bs' },
  { name: 'Barbados Dollar', code: 'bbd', symbol: '$', countryCode: 'bb' },
  { name: 'Belarus Ruble', code: 'byn', symbol: 'Br', countryCode: 'by' },
  { name: 'Belize Dollar', code: 'bzd', symbol: 'BZ$', countryCode: 'bz' },
  { name: 'Bermuda Dollar', code: 'bmd', symbol: '$', countryCode: 'bm' },
  { name: 'Bolivia Bolíviano', code: 'bob', symbol: '$b', countryCode: 'bo' },
  { name: 'Bosnia and Herzegovina Convertible Mark', code: 'bam', symbol: 'KM', countryCode: 'ba' },
  { name: 'Botswana Pula', code: 'bwp', symbol: 'P', countryCode: 'bw' },
  { name: 'Bulgaria Lev', code: 'bgn', symbol: 'лв', countryCode: 'bg' },
  { name: 'Brazil Real', code: 'brl', symbol: 'R$', countryCode: 'br' },
  { name: 'Brunei Darussalam Dollar', code: 'bnd', symbol: '$', countryCode: 'bn' },
  { name: 'Cambodia Riel', code: 'khr', symbol: '៛', countryCode: 'kh' },
  { name: 'Canada Dollar', code: 'cad', symbol: '$', countryCode: 'ca' },
  { name: 'Cayman Islands Dollar', code: 'kyd', symbol: '$', countryCode: 'ky' },
  { name: 'Chile Peso', code: 'clp', symbol: '$', countryCode: 'cl' },
  { name: 'China Yuan Renminbi', code: 'cny', symbol: '¥', countryCode: 'cn' },
  { name: 'Colombia Peso', code: 'cop', symbol: '$', countryCode: 'co' },
  { name: 'Costa Rica Colon', code: 'crc', symbol: '₡', countryCode: 'cr' },
  { name: 'Croatia Kuna', code: 'hrk', symbol: 'kn', countryCode: 'hr' },
  { name: 'Cuba Peso', code: 'cup', symbol: '₱', countryCode: 'cu' },
  { name: 'Czech Republic Koruna', code: 'czk', symbol: 'Kč', countryCode: 'cz' },
  { name: 'Denmark Krone', code: 'dkk', symbol: 'kr', countryCode: 'dk' },
  { name: 'Dominican Republic Peso', code: 'dop', symbol: 'RD$', countryCode: 'do' },
  { name: 'East Caribbean Dollar', code: 'xcd', symbol: '$', countryCode: 'ag' },
  { name: 'East Caribbean Dollar', code: 'xcd', symbol: '$', countryCode: 'dm' },
  { name: 'East Caribbean Dollar', code: 'xcd', symbol: '$', countryCode: 'gd' },
  { name: 'East Caribbean Dollar', code: 'xcd', symbol: '$', countryCode: 'kn' },
  { name: 'East Caribbean Dollar', code: 'xcd', symbol: '$', countryCode: 'lc' },
  { name: 'East Caribbean Dollar', code: 'xcd', symbol: '$', countryCode: 'vc' },
  { name: 'East Caribbean Dollar', code: 'xcd', symbol: '$', countryCode: 'vg' },
  { name: 'Egypt Pound', code: 'egp', symbol: '£', countryCode: 'eg' },
  { name: 'El Salvador Colon', code: 'svc', symbol: '$', countryCode: 'sv' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'ad' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'at' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'be' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'cy' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'ee' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'fi' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'fr' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'de' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'gr' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'ie' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'it' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'lv' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'lt' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'lu' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'mt' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'mc' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'me' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'nl' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'pt' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'sm' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'sk' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'si' },
  { name: 'Euro Member Countries', code: 'eur', symbol: '€', countryCode: 'va' },
  { name: 'Falkland Islands (Malvinas) Pound', code: 'fkp', symbol: '£', countryCode: 'fk' },
  { name: 'Fiji Dollar', code: 'fjd', symbol: '$', countryCode: 'fj' },
  { name: 'Ghana Cedi', code: 'ghs', symbol: '¢', countryCode: 'gh' },
  { name: 'Gibraltar Pound', code: 'gip', symbol: '£', countryCode: 'gi' },
  { name: 'Guatemala Quetzal', code: 'gtq', symbol: 'Q', countryCode: 'gt' },
  { name: 'Guernsey Pound', code: 'ggp', symbol: '£', countryCode: 'gg' },
  { name: 'Guyana Dollar', code: 'gyd', symbol: '$', countryCode: 'gy' },
  { name: 'Honduras Lempira', code: 'hnl', symbol: 'L', countryCode: 'hn' },
  { name: 'Hong Kong Dollar', code: 'hkd', symbol: '$', countryCode: 'hk' },
  { name: 'Hungary Forint', code: 'huf', symbol: 'Ft', countryCode: 'hu' },
  { name: 'Iceland Krona', code: 'isk', symbol: 'kr', countryCode: 'is' },
  {
    name: 'India Rupee',
    code: 'inr',
    symbol: '₹',
    countryCode: 'in',
    localName: 'रुपये',
    englishName: 'Rupees',
  },
  { name: 'Indonesia Rupiah', code: 'idr', symbol: 'Rp', countryCode: 'id' },
  { name: 'Iran Rial', code: 'irr', symbol: '﷼', countryCode: 'ir' },
  { name: 'Isle of Man Pound', code: 'imp', symbol: '£', countryCode: 'im' },
  { name: 'Israel Shekel', code: 'ils', symbol: '₪', countryCode: 'il' },
  { name: 'Jamaica Dollar', code: 'jmd', symbol: 'J$', countryCode: 'jm' },
  { name: 'Japan Yen', code: 'jpy', symbol: '¥', countryCode: 'jp' },
  { name: 'Jersey Pound', code: 'jep', symbol: '£', countryCode: 'je' },
  { name: 'Kazakhstan Tenge', code: 'kzt', symbol: 'лв', countryCode: 'kz' },
  { name: 'Korea (North) Won', code: 'kpw', symbol: '₩', countryCode: 'kp' },
  { name: 'Korea (South) Won', code: 'krw', symbol: '₩', countryCode: 'kr' },
  { name: 'Kyrgyzstan Som', code: 'kgs', symbol: 'лв', countryCode: 'kg' },
  { name: 'Laos Kip', code: 'lak', symbol: '₭', countryCode: 'la' },
  { name: 'Lebanon Pound', code: 'lbp', symbol: '£', countryCode: 'lb' },
  { name: 'Liberia Dollar', code: 'lrd', symbol: '$', countryCode: 'lr' },
  { name: 'Macedonia Denar', code: 'mkd', symbol: 'ден', countryCode: 'mk' },
  { name: 'Malaysia Ringgit', code: 'myr', symbol: 'RM', countryCode: 'my' },
  { name: 'Mauritius Rupee', code: 'mur', symbol: '₨', countryCode: 'mu' },
  { name: 'Mexico Peso', code: 'mxn', symbol: '$', countryCode: 'mx' },
  { name: 'Mongolia Tughrik', code: 'mnt', symbol: '₮', countryCode: 'mn' },
  { name: 'Moroccan Dirham', code: 'mad', symbol: 'د.إ', countryCode: 'ma' },
  { name: 'Mozambique Metical', code: 'mzn', symbol: 'MT', countryCode: 'mz' },
  { name: 'Namibia Dollar', code: 'nad', symbol: '$', countryCode: 'na' },
  { name: 'Nepal Rupee', code: 'npr', symbol: '₨', countryCode: 'np' },
  { name: 'Netherlands Antilles Guilder', code: 'ang', symbol: 'ƒ', countryCode: 'an' },
  { name: 'New Zealand Dollar', code: 'nzd', symbol: '$', countryCode: 'nz' },
  { name: 'Nicaragua Cordoba', code: 'nio', symbol: 'C$', countryCode: 'ni' },
  { name: 'Nigeria Naira', code: 'ngn', symbol: '₦', countryCode: 'ng' },
  { name: 'Norway Krone', code: 'nok', symbol: 'kr', countryCode: 'no' },
  { name: 'Oman Rial', code: 'omr', symbol: '﷼', countryCode: 'om' },
  { name: 'Pakistan Rupee', code: 'pkr', symbol: '₨', countryCode: 'pk' },
  { name: 'Panama Balboa', code: 'pab', symbol: 'B/.', countryCode: 'pa' },
  { name: 'Paraguay Guarani', code: 'pyg', symbol: 'Gs', countryCode: 'py' },
  { name: 'Peru Sol', code: 'pen', symbol: 'S/.', countryCode: 'pe' },
  { name: 'Philippines Peso', code: 'php', symbol: '₱', countryCode: 'ph' },
  { name: 'Poland Zloty', code: 'pln', symbol: 'zł', countryCode: 'pl' },
  { name: 'Qatar Riyal', code: 'qar', symbol: '﷼', countryCode: 'qa' },
  { name: 'Romania Leu', code: 'ron', symbol: 'lei', countryCode: 'ro' },
  { name: 'Russia Ruble', code: 'rub', symbol: '₽', countryCode: 'ru' },
  { name: 'Saint Helena Pound', code: 'shp', symbol: '£', countryCode: 'sh' },
  { name: 'Saudi Arabia Riyal', code: 'sar', symbol: '﷼', countryCode: 'sa' },
  { name: 'Serbia Dinar', code: 'rsd', symbol: 'Дин.', countryCode: 'rs' },
  { name: 'Seychelles Rupee', code: 'scr', symbol: '₨', countryCode: 'sc' },
  { name: 'Singapore Dollar', code: 'sgd', symbol: '$', countryCode: 'sg' },
  { name: 'Solomon Islands Dollar', code: 'sbd', symbol: '$', countryCode: 'sb' },
  { name: 'Somalia Shilling', code: 'sos', symbol: 'S', countryCode: 'so' },
  { name: 'South Korean Won', code: 'krw', symbol: '₩', countryCode: 'kr' },
  { name: 'South Africa Rand', code: 'zar', symbol: 'R', countryCode: 'za' },
  { name: 'Sri Lanka Rupee', code: 'lkr', symbol: '₨', countryCode: 'lk' },
  { name: 'Sweden Krona', code: 'sek', symbol: 'kr', countryCode: 'se' },
  { name: 'Switzerland Franc', code: 'chf', symbol: 'CHF', countryCode: 'ch' },
  { name: 'Suriname Dollar', code: 'srd', symbol: '$', countryCode: 'sr' },
  { name: 'Syria Pound', code: 'syp', symbol: '£', countryCode: 'sy' },
  { name: 'Taiwan New Dollar', code: 'twd', symbol: 'NT$', countryCode: 'tw' },
  { name: 'Thailand Baht', code: 'thb', symbol: '฿', countryCode: 'th' },
  { name: 'Trinidad and Tobago Dollar', code: 'ttd', symbol: 'TT$', countryCode: 'tt' },
  { name: 'Turkey Lira', code: 'try', symbol: '₺', countryCode: 'tr' },
  { name: 'Tuvalu Dollar', code: 'tvd', symbol: '$', countryCode: 'tv' },
  { name: 'Ukraine Hryvnia', code: 'uah', symbol: '₴', countryCode: 'ua' },
  { name: 'UAE Dirham', code: 'aed', symbol: 'د.إ', countryCode: 'ae' },
  { name: 'United Kingdom Pound', code: 'gbp', symbol: '£', countryCode: 'gb' },
  { name: 'United States Dollar', code: 'usd', symbol: '$', countryCode: 'us' },
  { name: 'Uruguay Peso', code: 'uyu', symbol: '$U', countryCode: 'uy' },
  { name: 'Uzbekistan Som', code: 'uzs', symbol: 'лв', countryCode: 'uz' },
  { name: 'Venezuela Bolívar', code: 'vef', symbol: 'Bs', countryCode: 've' },
  { name: 'Viet Nam Dong', code: 'vnd', symbol: '₫', countryCode: 'vn' },
  { name: 'Yemen Rial', code: 'yer', symbol: '﷼', countryCode: 'ye' },
  { name: 'Zimbabwe Dollar', code: 'zwd', symbol: 'Z$', countryCode: 'zw' },
]

